var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiryPrimaryRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 403.9 152",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M71.5.1C34.3 2.4 3.8 32 .5 69.2c-1.1 13 1 25.4 5.7 36.4.5 1.3.7 2.7.4 4L0 139c0 .2.1.3.2.3l28.3-2.5c1.2-.1 2.5.3 3.5 1.1 12.7 9.1 28.3 14.4 45.1 14.2 41.8-.5 75.7-35.5 75.1-77.3-.7-43-37-77.3-80.7-74.7z",
    fill: "#4bb3fd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m242.8 119.7-12.7-30.4h-41l-12.6 30.4h-12L205 23.8h10l40.3 95.9zm-16.2-40.1L214.7 50c-1.5-3.7-3.1-8.3-4.8-13.8-1 4.2-2.5 8.8-4.4 13.8l-12.1 29.6zm49.1 40.1h-10.6V48.3h10.6zm47.4-72.8c3.2 0 6 .3 8.5.8l-1.5 10c-2.9-.7-5.5-1-7.8-1-5.8 0-10.7 2.3-14.8 7s-6.1 10.5-6.1 17.5v38.4h-10.8V48.2h9.7v9.5s3.4-5.6 9.3-8c5.8-2.4 9-2.8 13.5-2.8zm14 1.4h11.6l15.6 40.8c3.4 9.3 5.5 16 6.4 20.2h.5c.6-2.2 1.7-6 3.5-11.4s7.7-21.9 17.6-49.6h11.6l-30.6 81.5c-3 8.1-6.6 13.8-10.6 17.1-4 3.4-9 5.1-14.9 5.1-3.3 0-6.5-.4-9.7-1.1v-8.7c2.4.5 5 .8 8 .8 7.4 0 12.7-4.2 15.8-12.5l4-10.2zm-66.6-9.2c-4.2 0-7.6-3.4-7.6-7.6s3.4-7.6 7.6-7.6 7.6 3.4 7.6 7.6-3.5 7.6-7.6 7.6z",
    fill: "#133c55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m123.6 109.8-25.7 10.4-34.5-85.9 25.7-10.4zM72.8 70.5 42.5 82.7 60.6 40zm20.7 51.4L44 87.5l30.7-12.3zm-35.3-18.3-29.6 11.9 10.7-25.1z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiryPrimaryRgb);
export default __webpack_public_path__ + "static/media/airy_primary_rgb.03561cae.svg";
export { ForwardRef as ReactComponent };